var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ad45375a0b87d34eb9dd43bd4e1cbb3bd5baa9d3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["buscounchollo-prod@sentry"]={id:"ad45375a0b87d34eb9dd43bd4e1cbb3bd5baa9d3"};
      